"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItemText = exports.StyledChildListItem = exports.StyledListSubheader = exports.StyledUl = exports.StyledTypography = exports.StyledMenuContent = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMenuContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: ${({ theme }) => theme.spacing(1.5)};
  max-height: 300px;
  min-width: 300px;

  &.menu-content--searching .MuiTypography-root {
    color: ${({ theme }) => theme.palette.grey[500]};
  }

  .loading-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }
`;
exports.StyledTypography = (0, styled_components_1.default)(ui_components_1.Typography) `
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;
exports.StyledUl = styled_components_1.default.ul `
  padding: ${({ theme }) => theme.spacing(1.2)} 0;
`;
exports.StyledListSubheader = (0, styled_components_1.default)(material_1.ListSubheader) `
  padding: 0;
  z-index: 3;

  .subheader-content {
    display: flex;
    align-items: center;
    gap:  ${({ theme }) => theme.spacing(2)};
  }
`;
exports.StyledChildListItem = (0, styled_components_1.default)(material_1.ListItem) `
  padding-left: ${({ theme }) => theme.spacing(10)};
`;
exports.StyledListItemText = (0, styled_components_1.default)(material_1.ListItemText) `
  .MuiTypography-root {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
`;
